import {Injectable} from '@angular/core'
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http'
import {Router} from '@angular/router'
import {Observable} from 'rxjs'

import {Config} from '@chatize-ui/services/config'
import {DEFAULT_LANG} from '@chatize-ui/constants/default-lang'

import {getUrlDetails} from '@products-ui/core/utils/get-url-details'

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private config: Config,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const {lang} = getUrlDetails(this.config.languages, this.router.url)

    return next.handle(
      req.clone({
        setHeaders: {
          'Accept-Language': lang ?? DEFAULT_LANG,
        },
      }),
    )
  }
}
